import './App.css';
import ChatbotWidget from './ChatbotWidget';
import { useParams } from 'react-router';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import ChatbotWidgetDemo from './ChatbotWidgetDemo';

export async function loader({ params, request }) {
  console.log('params', params)
  const id = params.id;
  const url = new URL(request.url);
  const o = url.searchParams.get('o');
  return { id, o };
}

const router = createBrowserRouter([
  {
    path: "/demo/:id",
    element: <ChatbotWidgetDemo></ChatbotWidgetDemo>,
    loader: loader
  },
  {
    path: "/chat/:id",
    element: <ChatbotWidget></ChatbotWidget>,
    loader: loader
  }
]);

function App() {
  return (
    <div className="h-screen w-screen bg-transparent">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
